import { Fragment, useState } from 'react';
import { IconButton } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import StayCurrentPortraitIcon from '@material-ui/icons/StayCurrentPortrait';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useNotify, Record, useTranslate } from 'react-admin';
import MenuButtonActions from '../../UI/MenuButtonActions/MenuButtonActions';
import ShowQrDialog from '../../qr/ShowQrDialog';
import { openBackofficeApp } from '../../../utils/backofficeApp';

interface Props {
    mc: Record;
}

const McConfigMenu = ({ mc }: Props) => {
    const notify = useNotify();
    const t = useTranslate();
    const [showQrDialog, setShowQrDialog] = useState(false);

    const handleSimulateApp = () => {
        window.open(mc.yourls.mcUrl, '_blank', 'width=411px,height=731px');
    };

    const handleOpenBackofficeForms = () => {
        if (mc.yourls?.mcUrl) {
            openBackofficeApp(mc.yourls.mcUrl, 'forms', {
                onMissingRefreshToken: () => notify(t('app.ancs.backofficeMissingRefresh'), 'warning'),
            });
        }
    };

    const handleOpenBackofficeDocuments = () => {
        if (mc.yourls?.mcUrl) {
            openBackofficeApp(mc.yourls.mcUrl, 'documents', {
                onMissingRefreshToken: () => notify(t('app.ancs.backofficeMissingRefresh'), 'warning'),
            });
        }
    };

    const handleShowQr = () => {
        setShowQrDialog(true);
    };

    const handleCopyUrl = async () => {
        const mcUrl = mc.yourls?.mcUrl || mc.yourls?.short;
        if (mcUrl) {
            try {
                // Usar la misma implementación que el proyecto ya usa
                await navigator.clipboard.writeText(mcUrl);
                notify('app.notification.copied');
            } catch (error) {
                console.warn('Clipboard operation failed:', error);
                notify('Error al copiar URL', 'error');
            }
        }
    };

    const menuActions = [
        {
            icon: <StayCurrentPortraitIcon />,
            text: 'app.objects2.actions.simulateWebApp',
            onClick: handleSimulateApp,
            disabled: false,
        },
        {
            icon: <AssignmentIcon />,
            text: 'app.ancs.backofficeForms',
            onClick: handleOpenBackofficeForms,
            disabled: !mc.yourls?.mcUrl,
        },
        {
            icon: <CloudUploadIcon />,
            text: 'app.ancs.backofficeDocuments',
            onClick: handleOpenBackofficeDocuments,
            disabled: !mc.yourls?.mcUrl,
        },
        {
            icon: (
                <img
                    src='/images/qr-icon.svg'
                    alt='QR Code'
                    style={{
                        width: 24,
                        height: 24,
                    }}
                />
            ),
            text: 'app.objects.qrCode',
            onClick: handleShowQr,
            disabled: false,
        },
        {
            icon: <FileCopyIcon />,
            text: 'app.mc.copy',
            onClick: handleCopyUrl,
            disabled: false,
        },
    ];

    return (
        <Fragment>
            <MenuButtonActions
                menuActions={menuActions}
                buttonLabel='Configurar MC'
                overwriteButtonLabel
                customButton={
                    <IconButton color='primary' size='small' style={{ padding: '8px' }}>
                        <SettingsIcon />
                    </IconButton>
                }
            />

            <ShowQrDialog open={showQrDialog} onClose={() => setShowQrDialog(false)} mc={mc} />
        </Fragment>
    );
};

export default McConfigMenu;
